/* WGD store layer of the EK etalon product page (from the WCA layer): SureBright draws its widget in an open shadow root, which page CSS
   cannot reach; this adds one constructed style sheet to that root. v3 row 3 (wca-D-20261024-3): the widget keeps the
   app's own layout as in v1 (card, description line, feature pills, dropdown; ek-themes 00bb06a) and sits above Add to
   cart as in v2; only the colours are the store palette (wca-D-20261023-29). The app's own files are not touched; the
   colours are the etalon tokens, which custom properties carry into the shadow root. */
(function () {
  var CSS = [
    '.sb-offering-wrapper{border-color:var(--ek-pdp-border,#e4e4e5)!important;border-radius:12px!important;background:var(--ek-pdp-bg,#ffffff)!important}',
    '.sb-content-heading{color:var(--ek-pdp-text,#2a2b2a)!important}',
    '.sb-content-desc{color:var(--ek-pdp-muted,#5f5f5f)!important}',
    '.sb-content-desc .sb-learn-more{color:var(--ek-pdp-wine,#541327)!important}',
    '.sb-feature-pills{flex-wrap:wrap!important;overflow:visible!important;gap:6px!important;justify-content:flex-start!important}',
    '.sb-feature-pill{background:var(--ek-pdp-surface-alt,#f5f5f5)!important;color:var(--ek-pdp-text,#2a2b2a)!important;border:1px solid var(--ek-pdp-border,#e4e4e5)!important}',
    '.sb-feature-pill__icon{color:var(--ek-pdp-petrol,#0E4F5C)!important}',
    '.sb-policy-dropdown-v2__trigger{border-radius:10px!important;border-color:var(--ek-pdp-border,#e4e4e5)!important}',
    '.sb-policy-dropdown-v2__trigger:focus-visible{outline:2px solid var(--ek-pdp-petrol,#0E4F5C)!important;outline-offset:2px}',
    '.sb-policy-dropdown-v2__trigger-label,.sb-policy-dropdown-v2__trigger-price{color:var(--ek-pdp-text,#2a2b2a)!important}',
    '.sb-policy-dropdown-v2__option--selected{background:var(--ek-pdp-petrol-soft,#f2f4f5)!important}'
  ].join('');
  var sheet = null;
  var style = function (el) {
    var root = el.shadowRoot;
    if (!root || root.__ekStyled) return;
    root.__ekStyled = true;
    try {
      if (!sheet) { sheet = new CSSStyleSheet(); sheet.replaceSync(CSS); }
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    } catch (e) {
      var s = document.createElement('style');
      s.textContent = CSS;
      root.appendChild(s);
    }
  };
  var scan = function () { document.querySelectorAll('.ek-main-product sb-product-widget').forEach(style); };
  var start = function () {
    scan();
    if (window.customElements) window.customElements.whenDefined('sb-product-widget').then(function () { window.requestAnimationFrame(scan); });
    var info = document.querySelector('.ek-main-product .product-info');
    if (!info || !('MutationObserver' in window)) return;
    var queued = false;
    /* a new widget (first render, or re-created by the app) → style it once; a styled root is skipped */
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; scan(); });
    }).observe(info, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
